import { Card, Progress } from "@repo/ui";

export function CompatibilityResult() {
  const params = new URLSearchParams(window.location.search);
  const a = params.get("personA") || "";
  const b = params.get("personB") || "";

  const res = computeCompatibility(a, b);
  document.title = `ความเข้ากันได้ ${res.score}% — Lucky News`;

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="font-display text-3xl">ผลความเข้ากันได้</h1>
      <Card className="p-6 bg-card/60">
        <div className="text-sm text-foreground/70">
          {fmt(a)} ⇄ {fmt(b)}
        </div>
        <div className="mt-4 text-4xl font-display">{res.score}%</div>
        <Progress value={res.score} className="mt-3" />
        <p className="mt-4 text-foreground/80 whitespace-pre-line">{res.text}</p>
        <div className="mt-6 grid md:grid-cols-3 gap-4 text-sm">
          <div>
            <div className="font-display">พลังบวก</div>
            <ul className="list-disc list-inside text-foreground/80">
              {res.positives.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-display">สิ่งที่ต้องระวัง</div>
            <ul className="list-disc list-inside text-foreground/80">
              {res.cautions.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-display">เคล็ดลับ</div>
            <ul className="list-disc list-inside text-foreground/80">
              {res.tips.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      </Card>
    </div>
  );
}

function computeCompatibility(a: string, b: string) {
  const sumDigits = (s: string) =>
    s
      .replace(/\D/g, "")
      .split("")
      .reduce((acc, d) => acc + parseInt(d), 0);
  const sa = sumDigits(a);
  const sb = sumDigits(b);
  const seed = (sa * 7 + sb * 11 + (new Date().getFullYear() % 100)) % 101;
  const score = 50 + ((seed % 51) - 25); // 25-75 range around 50
  const clamp = Math.max(0, Math.min(100, score));
  const texts = [
    "พลังงานโดยรวมเข้ากันได้ดี มีความเข้าใจและพร้อมสนับสนุนกัน",
    "ความต่างทำให้เกิดความลงตัว หากสื่อสารดีจะไปได้ไกล",
    "มีความคล้ายกันสูง แต่ต้องระวังความคาดหวังที่มากเกินไป",
    "ช่วงนี้ต้องให้พื้นที่กันและกันมากขึ้น จะช่วยให้ความสัมพันธ์ราบรื่น",
  ];
  const pick = (arr: string[], off: number) => arr[(seed + off) % arr.length];
  return {
    score: Math.round(clamp),
    text: pick(texts, 1),
    positives: ["เปิดใจรับฟัง", "พร้อมพัฒนา", "มีเป้าหมายร่วมกัน"],
    cautions: ["อารมณ์แปรปรวน", "คาดหวังสูง", "ตารางเวลาไม่ตรงกัน"],
    tips: ["นัดคุยอย่างตั้งใจสัปดาห์ละครั้ง", "หากิจกรรมใหม่ทำด้วยกัน", "ให้กำลังใจอย่างจริงใจ"],
  };
}

function fmt(s: string) {
  const d = new Date(s);
  return d.toLocaleDateString("th-TH");
}

export default CompatibilityResult;
